import axios from 'axios';

// Docker'da nginx proxy /api/* → backend:3001
// Geliştirmede REACT_APP_API_URL=http://localhost:3001/api kullan
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const code = err.response?.data?.code;

    if (status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    // 402 PAYMENT_REQUIRED — paymentSoftBlock middleware (trial expired / inactive)
    if (status === 402 && code === 'PAYMENT_REQUIRED') {
      window.dispatchEvent(new CustomEvent('payment-required', {
        detail: err.response.data,
      }));
    }

    // 409 CONSENT_OUTDATED — requireUpToDateConsents middleware
    if (status === 409 && code === 'CONSENT_OUTDATED') {
      window.dispatchEvent(new CustomEvent('consent-outdated', {
        detail: err.response.data,
      }));
    }

    return Promise.reject(err);
  }
);

export default api;
